<template>
    <form @submit="submitList">

    <h4>New List</h4>

      <p v-if="errors.length">
        <b>Please correct the following error(s):</b>
        <ul>
          <li v-bind:key="error" v-for="error in errors">{{ error }}</li>
        </ul>
      </p>

      <p>
        <input type="text" name="title" id="title" v-model="title" placeholder="Title...">
      </p>

      <p>
        <button type="submit">Create</button>
      </p>
    </form>
</template>

<script>
import ListsService from '@/services/ListsService'
export default {
  name: 'list',
  data () {
    return {
      title: '',
      errors: []
    }
  },
  mounted () {
    //
  },
  methods: {
    submitList: function (e) {
      e.preventDefault()
      this.errors = []

      if (this.title === '') {
        this.errors = ['List name is required']
        return
      }

      ListsService.createList({title: this.title})
        .then((result) => {
          this.$router.push({ name: 'ListView', params: { id: result.data.id } })
        })
        .catch((err) => {
          let response = err.response.data
          if (response.error) {
            this.errors = [response.message]
          }
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/CreateList.vue